module.exports = "<script type=\"text/html\" id=\"propertyeditorcontent-nested\">\n    <div style=\"padding-left: 10px;\">\n        <button type=\"button\" class=\"btn btn-sm btn-secondary\" data-bind=\"click: onReturnToListClick\">\n            <span class=\"glyphicon glyphicon-list-alt\"></span>\n        </button>\n        <span data-bind=\"text: koEditorName\"></span>\n      <!-- ko template: { name: \"questioneditor-content\", data: koEditItem().itemEditor } -->\n      <!-- /ko -->\n  </div>\n</script>\n";


//////////////////
// WEBPACK FOOTER
// ./src/templates/propertyEditors/propertyeditor-nested.html
// module id = 124
// module chunks = 0